import {useEffect, useState} from "react";
import {Button, Grid, Typography} from "@mui/material";
import {FileInputEntry, IFileData} from "@shared/specialComponents/FileInputEntry.tsx";
import {DataGrid, GridColDef} from "@mui/x-data-grid";
import {Publish} from "@mui/icons-material";
import {usePublic} from "@shared/hooks/usePublic.ts";
import {IEmpresa} from "@models/empresa/IEmpresa.ts";
import {useEmpresa} from "@components/empresas/hooks/useEmpresa.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {ToCpfCnpj} from "@shared/ValidationHelp.ts";
import {ICreateEmpresaDto} from "@models/empresa/dto/ICreateEmpresaDto.ts";

interface ImportEmpresaComponentProps {
    onCreate?: (v: IEmpresa[]) => void
}


export function ImportEmpresaComponent({onCreate}: ImportEmpresaComponentProps) {
    const {importEmpresas} = useEmpresa()
    const {getTemplate, importFromFile} = usePublic()
    const {createAlertFromResponse} = useAlert()
    const [fileData, setFileData] = useState<IFileData[]>([])
    const [fileExample, setFileExample] = useState<string | undefined>(undefined)
    const [preview, setPreview] = useState<ICreateEmpresaDto[]>([])


    useEffect(() => {
        fetch(getTemplate('empresa', 'import-example')).then(x => x.blob()).then(x => {
            const url = URL.createObjectURL(x)
            setFileExample(url)
        })

        return () => {
            if (fileExample) {
                URL.revokeObjectURL(fileExample)
            }
        }
    }, []);
    const datagridColumns: GridColDef[] = [
        {field: 'id', headerName: '#', width: 90},
        {field: 'nroFilial', headerName: 'nroFilial', width: 130},
        {field: 'nome', headerName: 'nome', width: 130},
        {field: 'cnpj', headerName: 'cnpj', width: 130},
    ]


    useEffect(() => {
        if (fileData?.length > 0) {
            importFromFile<ICreateEmpresaDto>(fileData[0]).then(x => {
                setPreview(x.map((x, i) => {
                    return {
                        id: i,
                        nome: x.nome,
                        cnpj: ToCpfCnpj(x.cnpj),
                        nroFilial: x.nroFilial,
                    }
                }))
            })
        } else {
            setPreview([])
        }
        return;

    }, [fileData])

    return (
        <Grid container>
            <Grid size={12}>
                <Typography variant={'caption'}
                >
                    Importe um arquivo CSV com os dados dos recursos baixe o
                    <Typography
                        variant={'caption'}
                        component={'a'}
                        href={fileExample || '#'}
                        download="import-empresa.csv"
                        sx={{cursor: 'pointer', textDecoration: 'underline', mx: 0.5}}
                    >
                        arquivo exemplo
                    </Typography>
                    e preencha os campos.
                </Typography>
            </Grid>
            <Grid container justifyContent={'space-between'} size={12}>
                <Grid>
                    <FileInputEntry fileType={'csv'} files={fileData} onChange={(v) => {
                        if (v != null)
                            setFileData(v)
                    }}/>
                </Grid>
                <Grid>
                    <Button disabled={preview.length == 0}
                            endIcon={<Publish/>}
                            onClick={() => {
                                importEmpresas(preview).then(x => {
                                    createAlertFromResponse(x)
                                    if (x.status == 'Success') {
                                        if (onCreate != null)
                                            onCreate(x.items)
                                    }
                                })
                            }}
                    >Enviar</Button>
                </Grid>
            </Grid>
            {preview.length > 0 &&
                <Grid size={12}>
                    <DataGrid columns={datagridColumns} rows={preview} initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10
                            }
                        }
                    }}/>
                </Grid>}

        </Grid>
    )
}